import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGruposDeClasificacionConsulta } from '../../shared/interfaces/sisben/sisben';

@Injectable({
  providedIn: 'root'
})
export class GruposClasificacionService {
  private readonly baseUrl = `${environment.apiUrl}/api/datasets-dinamicos/sisben/grupos-clasificacion`;

  constructor(private readonly http: HttpClient) { }

  findAll(): Observable<IGruposDeClasificacionConsulta[]> {
    return this.http.get<IGruposDeClasificacionConsulta[]>(this.baseUrl);
  }
}
